
export enum ESalutation {
  Herr = 0,
  Frau = 1,
  // Diver = 2,
}
